import {NgModule} from "@angular/core";
import {CommonModule, NgOptimizedImage} from "@angular/common";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from '@angular/material/input';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatButtonModule} from "@angular/material/button";
import {MatDatepicker, MatDatepickerModule} from '@angular/material/datepicker';
import {FeedbackComponent} from "./pages/feedback.component";
import {FeedbackRoutingModule} from "./feedback-routing.module";
import {StarRatingModule} from "../../shared/star-rating/star-rating.module";
import {HeaderComponent} from "./pages/header/header.component";
import {StepperComponent} from "./pages/header/stepper/stepper.component";
import {MatRadioButton, MatRadioGroup} from "@angular/material/radio";
import {MatCheckbox} from "@angular/material/checkbox";
import {RadioButtonModule} from "../../shared/radio-button/radio-button.module";
import {MenuRatingModule} from "../../shared/menu-rating/menu-rating.module";
import {LabelSectionPipe} from "../../shared/pipes/label-section.pipe";
import {MatSelectModule} from "@angular/material/select";
import {MatOptionModule} from "@angular/material/core";
import {SuccessComponent} from "./pages/success/success.component";
import {IConfig, NgxMaskDirective, provideEnvironmentNgxMask, provideNgxMask} from "ngx-mask";
import { ExpiredComponent } from "./pages/expired/expired.component";

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [FeedbackComponent, HeaderComponent, StepperComponent, SuccessComponent, ExpiredComponent, LabelSectionPipe],
  imports: [
    NgxMaskDirective,
    CommonModule,
    FeedbackRoutingModule,
    MatIconModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    MatDatepickerModule,
    MatDatepicker,
    StarRatingModule,
    MenuRatingModule,
    MatRadioButton,
    MatRadioGroup,
    MatCheckbox,
    RadioButtonModule,
    MatSelectModule,
    MatOptionModule,
    NgOptimizedImage,
  ],
  providers: [
    provideEnvironmentNgxMask(maskConfig),
  ]
})
export class FeedbackModule {
}
